import type {CSSProperties, ReactNode} from "react";
import {Box, Col, DSIcon, DSIconButton, Row, Text} from "@cdx/ds";

type DefaultLayoutModalProps = {
  title: ReactNode;
  onClose?: () => void;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export const DefaultLayoutModal = ({
  title,
  onClose,
  actions,
  children,
  className,
  style,
}: DefaultLayoutModalProps) => (
  <Col className={className} style={style}>
    <Row align="center" py="16px" px="24px" sp="16px" border="1pxBottom">
      <Text type="title22" color="primary">
        {title}
      </Text>
      {actions && (
        <Row sp="24px" align="center" flex="auto">
          {actions}
        </Row>
      )}
      {onClose && (
        <Box ml="auto">
          <DSIconButton
            variant="tertiary"
            icon={<DSIcon name="Close" label="Close" />}
            onClick={onClose}
            negatePadding
          />
        </Box>
      )}
    </Row>
    {children}
  </Col>
);
